import { gql } from '@apollo/client'

export const GET_ISSUE_ADD = gql`
    query AddIssue($guid: String!) {
        entity(guid: $guid) {
            guid
            ... on Magazine {
                canEdit
            }
        }
    }
`
